export default __webpack_public_path__ + "static/media/dyed-gourds.e87dfc4b.jpg";